/**
 * APCWO customisation for OrangeHRM — Event Notifications module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */

import EventNotificationList from './pages/EventNotificationList.vue';
import SaveEventNotification from './pages/SaveEventNotification.vue';
import EditEventNotification from './pages/EditEventNotification.vue';

export default {
  'apcwo-event-notification-list': EventNotificationList,
  'apcwo-event-notification-save': SaveEventNotification,
  'apcwo-event-notification-edit': EditEventNotification,
};
